import { render, staticRenderFns } from "./periodsList.vue?vue&type=template&id=4b267e1c&"
import script from "./periodsList.vue?vue&type=script&lang=js&"
export * from "./periodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports